const websiteText = {
  test: {
    pl: "To jest test",
    en: "This is a test",
  },
  learn_more: {
    pl: "Dowiedz się więcej",
    en: "Learn more",
  },
  loading: {
    pl: "Ładowanie...",
    en: "Loading...",
  },
  flip_phone: {
    pl: "Trzymaj telefon poziomo",
    en: "Hold your phone horizontally",
  },
  sb_what_is_it_des: {
    pl: `Smashboty to roboty, zaprojektowane do walki, konkurencja polega na stworzeniu robota, którym będzie się sterowało na arenie podczas zawodów.
    Arena jest rozmiarów 2x2 m, walka trwa do 3 minut lub do nokautu przeciwnika. 
    Na arenie moga znajdować się różnego rodzaju młoty, piły zapadnie kolce, które pomagają w zniszczeniu robota.
    Kategoria smashbot mini charakteryzuje się ograniczeniem wagowym do 454 g.`,
    en: `Smashbots are robots created to fight. In order to participate in the competition, you have to create a robot that will fight to it's death in the arena. 
    The arena is 2 by 2 meters in size. In order to win, you have to control your robot to destroy the other, or survive for 3 minutes.
    On the arena there might me various traps, such as hammers, spikes or pits.
    Category smashbot mini has a weight limit of 454 g`,
  },
  sb_my_role_des: {
    pl: `Jako koordynator projektu, zajmowałem się ustalaniem terminów spotkań, podziałem obowiązków oraz zamawianiem potrzebnych komponentów.
    Oprócz tego tworzyłem projekt robota, płytki PCB oraz pisałem kod znajdujący się na mikrokontrolerze.`,
    en: `As a project coordinator I've scheduled meetings, distributed tasks and  ordered components.
    Besides that, I was modeling the robot, designing the PCB and writing the C program for the mikrokontroler`,
  },
  sb_about_project_des: {
    pl: `Nasz robot, tak naprawdę składał sie z dwóch robotów. Zasady pozwalają na wystawienie do jednej walki większej ilości robotów, pod warunkiem że łącznie mieszczą się w masie.
    Pozwoliło nam to, na atakowanie przeciwnika z dwóch stron, przez co trudniej było mu sie obronić.
    Naszą taktyką było podjechanie pod przeciwnika, i przewrócenie go z wykorzystaniem znajdujących się z przodu wideł.
    Największym minusem naszego robota było to, że przez oszczędność na masie wykorzystaliśmy plastik jako obudowe, który jest znacznie słabszy od metalowych pancerzy użytych przez przeciwników.
    Dwa silniki DC i serwomechanizm był kontrolowany przez mikrokontorler Nordic Dongle, łączność z robotem zrealizowaliśmy przez protokół bluetooth`,
    en: `Out robot, consisted of two robots, as long as those weigh less than 454g it is within the rules to fight with multiple robots.
    This allowed us to attack from two opposite sides, it is difficult to defend from such an attack.
    Our tactic was simple, flip the enemy over, throw it out of the arena, or use the traps deployed by event organizers.
    Biggest drawback of our robot was it's armor, in order to fit two robots within the weight limit, we used plastic, which was much weaker than metal armor used by most of the enemies.
    Two DC motors and a servomechanism was controlled  by Nordic Dongle microcontroler. We communicated with the robot via bluetooth.`,
  },
  sb_robocomp2024_des: {
    pl: `Robocomp 2024 to wydarzenie zorganizowane przez koło naukowe Integra, odbyło sie w hali sportowej AGH.
    Były to nasze pierwsze zawody w tej kategorii. Pierwszą walke stoczyliśmy z robotem Murex, był to robot podobny do robota HUGE.
    Walkę udało nam się wygrać dzięki temu, że słaba konstrukcja przeciwnika, sprawiła że zniszczył się on przy swoim ataku pozostawiając naszego drugiego robota bez szwanku.
    Kolejną walke graliśmy na robota Szerszeń, walkę tą przegraliśmy. 
    Walke o 3 miejsce stoczyliśmy z robotem Wariat, który posiadał kręcące się ostrze z przodu. Nie miał on jednak możliwości jazdy do góry nogami, wykorzystaliśmy tą słabość wywracając przeciwnika.`,
    en: `Robocomp 2024 was an event organized by Integra science club. It took place in AGH sports hall.
    It was the first robotic event we took part in. Our first fight was against robot Murex, it was a robot similar to the robot HUGE.
    We managed to win this fight because the week construction of the enemy, made him decimate himself while destroying one of our robot.
    Second fight was against Szerszeń, we lost it.
    The 3rd place match was against a horizontal spinner called Wariat. It's weakness was, that the robot had no way of moving while on its back.
    We exploited that weakness to ground it.`,
  },
  sb_xChalange2024_des: {
    pl: `XChallange 2024 to największe tego typu wydarzenie w Polsce, odbyło sie ono w Rzeszowie. 
    Stoczyliśmy tu tylko jedna walkę, zostaliśmy pokonani przez spinnera Funciak z Serem. Szybkość i zwinność robota nie wiele pomaga, kiedy wjeżdża się w broń przeciwnika.`,
    en: `XChallange 2024 is the biggest event of this kind in Poland. It took place in Rzeszów.
    We lost our first fight against a spinner called Funciak z Serem, It turns out speed and agility are of no use, you rush into the blade of the enemy.`,
  },
  sb_what_is_it_bn: {
    pl: "Co to smashbot?",
    en: "What is smashbot?",
  },
  sb_my_role_bn: {
    pl: "Moja rola",
    en: "My role",
  },
  sb_about_project_bn: {
    pl: "O projekcie",
    en: "About the project",
  },
  sb_robocomp2024_bn: {
    pl: "Robocomp 2024",
    en: "Robocomp 2024",
  },
  sb_xChalange2024_bn: {
    pl: "XChallange 2024",
    en: "XChallange 2024",
  },
  smashbot_title: {
    pl: "Smashbot mini",
    en: "Smashbot mini",
  },
  origami_title: {
    pl: "Origami",
    en: "Origami",
  },
  origami_description: {
    pl: `Origami to japońska sztuka składania papieru bez cięcia i klejenia.
    Przez kilka ostatnich lat złożyłem wiele modeli z jednej kwadratowej kartki papieru.
    czasem sięgającej 100cm x 100cm. Oto kilka zdjęć papierowych, smoków, zwierząt, i nie tylko.`,
    en: `Origami is a Japanese art of folding paper with no cuts and no glue.
    During recent years I've folded many models from a single sheet of paper, sometimes as big as 100cm x 100cm.
    Heres some photos of paper dragons, animals, and other creatures`,
  },
  email_copy: {
    pl: "Kliknij by skopiować",
    en: "Click to copy",
  },
  about_me_description: {
    pl: `Cześć, jestem Adam.
    Studiuję Automatykę i Robotykę na AGH w Krakowie, skończyłem 1LO w Gliwicach.
    Od zawsze interesowałem się matematyką i fizyką, w liceum udało się zostać finalistą z olimpiad z tych przedmiotów.
    Równie długo zajmuję się programowaniem, chodziłem na różne zajęcia/koła naukowe, jednak większość umiejętności nabyłem sam.
    Od czystego programowania moje zainteresowania szybko przeszły na elektronikę, modelowanie oraz robotykę. 
    Najciekawsze są dla mnie projekty łączące te dziedziny.
    Podczas każdego z moich projektów starałem się wykorzystywać jak najwięcej nowych dla mnie technologii,
    Przez to dość szybko znajduję się w nowym języku, programie, lub dziedzinie.
    Przez lata udało mi się skończyć wiele projektów, stworzyłem tą stronę, aby zebrać ich opis w ciekawy sposób.
    Zapraszam więc do eksploracji klikając na porozmieszczane dookoła obiekty. Aby wyjść z przybliżenia kliknij escape albo w pustkę. Kamerę możesz obrócić przeciągając myszką.

    A tutaj kilka słów o mnie:
    Kiedy nie zajmuję się studiami, działam w kole naukowym Integra lub pracuję nad którymś z moich hobbystycznych projektów.
    Lubię się wspinać a czasem nawet pójdę biegać. W zimę jeżdżę na nartach.
    Wieczorami chętnie gram ze znajomymi w różne gry komputerowe, a kiedy uda nam się znaleźć termin, spotykamy się aby pograć w D&D, papierową grę RPG.
    Samotne wieczory często spędzam z dobrym (a przynajmniej taki jest zamysł) filmem, a w podróży pociągiem przyśpieszam upływ czasu audiobookiem.
    Nadmiar wolnego czasu zużywam na składanie origami.

    `,
    en: `Hi, I'am Adam
    I'am studying Automatic Control and Robotics at AGH UST Karcow, I've graduated from 1 LO in Gliwice.
    I've always been interested in Maths and Physics, in high school I achieved a finalist title in olympiads from those subjects
    Similarly, I've always been interested in programming, I've attended some science clubs, but I am mostly self-taught.
    From programming, my interests broadened to electronics, 3d modeling and robotics.
    I am most interested in projects connecting those fields.
    For each new project I tried to use new technologies.
    Because of that I quickly adapt to new programming languages and programs.
    Over the years I've created many projects, this website was made to gather them in a fun way.
    I encourage you to explore my space by clicking on the floating objects. You can exit the zoomed view by clicking on empty space or pressing escape. Move the camera by dragging mouse.
    
    A few words about me:
    When I am not studying, I'am working in Integra science club or on some of my hobby projects.
    I like to climb, sometimes I go running. In the winter I go skiing.
    In the evenings I enjoy to play computer games with my friends, whenever we find a fitting date, we schedule a D&D game, a table top RPG.
    I like to spend lonely evenings with a movie, to quicken the train rides I listen to audiobook.
    Whatever free time I have left, I spend on folding origami.
    `,
  },
  about_me_tech: {
    pl: ["Fusion 360", "Unity", "React", "Next.js", "APIs", "Matlab"],
    en: ["Fusion 360", "Unity", "React", "Next.js", "APIs", "Matlab"],
  },
  about_me_abilities: {
    pl: ["Programowanie", "Projektowanie PCB", "Modelowanie", "Druk 3D", "Matematyka", "Fizyka", "Elektronika", "Robotyka"],
    en: ["Programming", "PCB Design", "3D Modeling", "3D Printing", "Maths", "Physics", "Electronics", "Robotics"],
  },
  about_me_languages: {
    pl: ["python", "Java Script", "Type Script", "C#", "C/C++"],
    en: ["python", "Java Script", "Type Script", "C#", "C/C++"],
  },
  fractal_description: {
    pl: `Wybierz się w matematyczną podróż w głąb fraktali! 
    Wykorzystane obliczenia o dowolnej precyzji na karcie graficznej pozwalają na płynne renderowanie głębokich zbliżeń.
    Projekt stworzony w Unity, część po stronie procesora napisana w C#, po stronie karty graficznej w HLSL.
    Jeden z moich większych projektów programistycznych. Więcej renderów, dokładniejszy opis oraz samą aplikację można znaleźć w repozytorium`,
    en: `Embark on a mathematical journey into the depths of fractals.
    The use of arbitrary-precision arithmetic on the gpu enables a smooth experience on deep zooms.
    This project was made with Unity, cpu-side is codded in C# while the gpu-side shaders are coded in HLSL.
    It is one of my biggest projects. If you are interested, check the repository for more high-resolution renders, and a way to download the app.
    `,
  },
  fractal_title: {
    pl: "Nieskończony Generator Fraktali",
    en: "Infinite Fractal Renderer",
  },
  dnd_tweet1: {
    pl: `Świetne urządzenie!!!
    Zanim dowiedziałem się o istnieniu tego monitora zasobów, non stop musiałem gumować i ponownie zapisywać wszystkie rzeczy.
    Teraz: kilko kliknięć i wszystko mam ustawione, szybko i intuicyjnie
    Idealny gadżet dla każdego gracza!!!
    Wiadomo można zwyczajnie użyć telefonu...
    Takie rozwiązanie jest jednak znacznie fajniejsze`,
    en: `Just Great!!!
    Before I got my hands on this resource tracker, I had to write and erase everything over and over again.\
    Now: a few clicks and I am all set, quickly and hustle-free
    The perfect gadget for every player.
    Obviously you can just use your phone to track everything...
    This is way cooler though.`,
  },
  dnd_tweet2: {
    pl: `Wiele użytecznych funkcji. Można bez problemu zapisać swoje punkty wytrzymałości, komórki czarów, albo cokolwiek innego.
    Nie ważne jaką klasą byś nie grał zawsze się przyda, wiadomo dla barbarzyńcy to może być lekki przerost formy nad treścią, ale dla maga, barda czy innego druida, świetne!
    Całość umieszczona w obudowie z wbudowanym schowkiem na karty zaklęć, kostki. Na razie co prawda mało to ozdobne ale liczę na to, że autorowi uda się to jeszcze zmienić.
    No i do tego świeci się na wybrany kolor. Polecam 10/10`,
    en: `One device to track them all. Hit points, spell slots, class features, magic item usages, or anything else you can imagine.
    Doesn't matter which class you play, it'll be of use. Obviously it might be a bit of a overkill for a barbarian, but for a mage bard or druid it is perfect.
    Everything neatly packed into a housing with spell card and dice storage. Unfortunately it is not yet decorated, but I am hopeful the author will change this in the future.
    On top of that is is RGB. Would recommend 10/10`,
  },
  dnd_tweet3: {
    pl: `To już jakaś przesada, nie wierzę jakim wielkim nerdem trzeba być żeby mieć coś takiego.
    Nie dość że trzeba grać w D&D to jeszcze lubić elektronikę. Nie wyobrażam sobie nawet tego.
    Ale trzeba przyznać że fajnie się świeci.`,
    en: `ngl you have to be a turbo nerd to have something like that that.
    Being into electronics and playing D&D. Unimaginable for me.
    I do like the lights though.`,
  },
  suilo_gov_main: {
    pl: "Wybory do Samorządu",
    en: "Council Election",
  },
  suilo_gov_sub: {
    pl: "2020, 2021",
    en: "2020, 2021",
  },
  suilo_gov_des: {
    pl: "Wybory online przebiegły sprawnie ułatwiając pracę samorządu",
    en: "Online elections were successful, and made councilors job easier.",
  },
  suilo_student_main: {
    pl: "Usprawnienie Samorządu",
    en: "Improvement of Council",
  },
  suilo_student_sub: {
    pl: "",
    en: "",
  },
  suilo_student_des: {
    pl: "Usprawniło przepływ informacji między uczniami a Samorządem",
    en: "Made communication between students and School Council easier",
  },
  suilo_back_main: {
    pl: "Backend w Express",
    en: "Backend made with Express",
  },
  suilo_back_sub: {
    pl: "Java Script, Firebase",
    en: "Java Script, Firebase",
  },
  suilo_back_des: {
    pl: "Integracja autoryzacji, bazy danych noSQL Firestore",
    en: "Integration of authorization, noSQL Firestore databse",
  },
  suilo_front_main: {
    pl: "Frontend w React",
    en: "Frontend made with React",
  },
  suilo_front_sub: {
    pl: "Java Script",
    en: "Java Script",
  },
  suilo_front_des: {
    pl: "Interfejs administratora pozwala na edycję kontentu",
    en: "Admin interface allows for on-site content editions",
  },
  suilo_team_main: {
    pl: "Stworzone w grupie",
    en: "Made in a team",
  },
  suilo_team_sub: {
    pl: "3 os.",
    en: "of 3.",
  },
  suilo_team_des: {
    pl: "Byłem odpowiedzialny za stworzenie backendu",
    en: "I was responsible for developing backend",
  },
  suilo_title: {
    pl: "Strona Samorządu Uczniowskiego",
    en: "School Council Website",
  },
  github: {
    pl: "Zobacz na GitHub'ie",
    en: "View it on GitHub",
  },
  instagram: {
    pl: "Zobacz na Instagram'ie",
    en: "View it on Instagram",
  },
  ws_esp_description: {
    pl: `Stacją kontroluje mikrokontroler ESP32, jest osadzony na zaprojektowanej i wykonanej przeze mnie 2 warstwowej płytce PBC.
    Kontroler jest odpowiedzialny za przetwarzanie informacji ze wszystkich czujników oraz przesyłanie ich na serwer.
    Program napisałem w Arduino IDE`,
    en: `Wether station is controlled by ESP32 microcontroller soldered to a custom made pcb I've designed.
    It is responsible for getting all the data out of the sensors and sending it to the server.
    I 've written the program using Arduino IDE `,
  },
  ws_rm_description: {
    pl: `Czujnik Deszczu, którego działanie można zobaczyć na animacji, działa na zasadzie podwójnego basenu z wodą posiadającego dwa punkty równowagi.
    Kiedy do basenu naleje się wystarczająco dużo wody, mechanizm zmienia swoje położenie. Do basenu przymocowane są magnesy, dzięki czemu kontaktron, znajdujący się pod obudową wyczuwa zmienne pole magnetyczne.
    Eliminacja odbić kontaktrona jest dokonywana w programie. 
    Duża wielkość leja pozwoliła na osiągnięcie dobrej dokładności odczytu przy rozdzielczości 0.3mm opadu
    Dodatkowo lej jest wyposażony w grzanie który pozwoli na pomiar opadu nawet kiedy pada śnieg`,
    en: `You can see, how the rain meter functions on the animation. It is based on a pool with two stable configurations.
    After enough water drips into the pool, it switches it's position. Magnets are mounted to the mechanism which allows a reed switch to detect the position change.
    Reed switch debouncing is done in software.
    Because of the funnel size, meter achieves good accuracy with a resolution of 0.3mm.
    Additionally the funnel is heated, this allows for also measuring the snow `,
  },
  ws_wm_description: {
    pl: `Czujnik kierunku wiatru oparty jest na obracającym się wale napędzanym trzema łopatkami.
    Do wału przymocowane są dwa magnesy, które obracając się, mijają kontaktron.
     Kontroler sczytuje Generowane impulsy obliczając na podstawie ich częstotliwości prędkość obrotową.
     Charakterystyka czujnika jest liniowa, łatwo więc prędkość obrotową zamienić na prędkość wiatru.
     Wiatr ustawia łopatkę czujnika równolegle do kierunku w którym wieje. 
     Kierunek ten odczytywany jest za pomocą enkodera magnetycznego`,
    en: `Blowing wind drives the wind speed meter shaft with two magnets mounted to it.
    While they spin they activate a reed switch which sends signals to the microcontroller. 
    Since the characteristic of the meter closely resembles a linear one, it is simple to calculate the wind speed based on the frequency of the pulses
    Wind direction meter head shape ensures that is is always aligned with the wind.
    The direction is later read by a magnetic encoder.`,
  },
  ws_3dp_description: {
    pl: `Wszystkie elementy stacji (za wyjątkiem elektroniki śrub i łożysk) są zaprojektowane do druku 3d.
    Ich kształt jest dobrany tak, aby elementy mogły być wydrukowane w najbardziej korzystnej pod względem wytrzymałości orientacji.
    Sugerowany materiał to ASA, ze względu na dobrą odporność na warunki atmosferyczne oraz możliwość łatwego klejenia.
    Łączenie elementów zapewniają wtopione gwinty oraz śruby`,
    en: `Each element of the station (excluding electronics bolts and bearings) is designed to be 3d printed.
    Shape of the elements is chosen so that the print can be made in the orientation where the layers are the strongest.
    ASA is my material of choice due to its resistance to UV as well as the ease of glueing it together.
    The elements are connected with threaded inserts and bolts`,
  },
  ws_other_description: {
    pl: `Pozostałe pomiary są wykonywane przy pomocy czujników bme280, oraz pms5003.
    Ten pierwszy odpowiada za pomiar temperatury, ciśnienia oraz wilgotności powietrza.
    Ten drugi odpowiada za pomiar zanieczyszczenia powietrza.
    Aktualna wersja stacji, jest trzecią iteracją tego projektu`,
    en: `Other measurements are made with bme280 and pms5003 meters.
    The first one measures temperature, pressure and humidity, while the other measures air quality.
    The current weather station is the third iteration of the project`,
  },
  ws_web_description: {
    pl: `Projekt ten jest realizowany wraz z moim tatą, on stworzył stronę na której można zobaczyć wszystkie dane.
    Docelowo będzie istniało kilka stacji których dane będzie można zobaczyć na stronie : www.stacja.fun
    Dostępne będą statystyki dzienne tygodniowe i miesięczne ze wszystkich pomiarów`,
    en: `The project is made in cooperation with my father, he is creating the website.
    On the www.stacja.fun website you will be able to see daily, weekly and monthly statistics from multiple weather stations.`,
  },
  ws_web_short_description: {
    pl: "Dane ze stacji można obejrzeć poprzez stronę internetową",
    en: "All the data can be viewed via a website",
  },
  ws_web_name: {
    pl: "Strona Internetowa",
    en: "Website",
  },
  ws_other_short_description: {
    pl: "Czujniki pms5003 oraz bme280 mierzą poziom zanieczyszczenia, temperaturę, ciśnienie oraz wilgotność",
    en: "pms5003 and bme280 are responsible for measuring air quality, temperature, pressure and humidity",
  },
  ws_other_name: {
    pl: "Pozostałe czujniki",
    en: "Other Meters",
  },
  ws_3dp_name: {
    pl: "Do druku 3d",
    en: "3d Printable",
  },
  ws_wm_short_description: {
    pl: "Osobne czujniki prędkości i kierunku wiatru zapewniają dokładne pomiary",
    en: "Two custom made meters allow for wind speed and direction measurements",
  },
  ws_wm_name: {
    pl: "Czujniki Wiatru",
    en: "Wind Meters",
  },
  ws_rm_short_description: {
    pl: "Stacja została wyposażona w ogrzewany czujnik deszczu i śniegu",
    en: "3d printed heated rain/snow meter enables accurate readings",
  },
  ws_rm_name: {
    pl: "Czujnik Deszczu",
    en: "Rain Meter",
  },
  ws_esp_name: {
    pl: "ESP32",
    en: "ESP32",
  },
  lang_bundle: {
    pl: "Język",
    en: "Language",
  },
  weather_bundle: {
    pl: "Stacja Pogodowa",
    en: "Weather Station",
  },
  suilo_bundle: {
    pl: "Strona SUILO",
    en: "SUILO Website",
  },
  dnd_bundle: {
    pl: "Monitor zasobów D&D",
    en: "D&D Tracker",
  },
  about_me_bundle: {
    pl: "O mnie",
    en: "About Me",
  },
  fractal_bundle: {
    pl: "Renderer Fraktalów",
    en: "Fractal Renderer",
  },
  origami_bundle: {
    pl: "Origami",
    en: "Origami",
  },
  smashbot_bundle: {
    pl: "Smashbot",
    en: "Smashbot",
  },
};
export default websiteText;
